import { useState } from "react";
import './style.css';
import api from "../../services/api";
import { Load } from "../../components/Load";
import AlertMessage from "../../components/Alert";
import voltarIcon from '../../img/icon/Voltar.svg'

const RecuperarSenha = () => {
    const [destinatario, setDestinatario] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [emailEnviado, setEmailEnviado] = useState(false);

    const handleOnChangeSenha = async (email: string) => {
        try {
            setDestinatario(email);
            setDisabled(false);
        } catch (error) {
            setAlert({ show: true, message: 'E-mail não encontrado.', variant: 'danger' });
        }
    }

    const handleEnviarSenha = async () => {
        try {
            if (destinatario !== '') {
                setIsLoading(true);
                const response = await api.post('enviar-email-recuperacao-senha', { destinatario });
                if (response.status === 200) {
                    setIsLoading(false);
                    setEmailEnviado(true);
                }
            }
        } catch (error: any) {
            setIsLoading(false);
            setAlert({ show: true, message: 'Erro ao enviar e-mail para redefinição de senha.', variant: 'danger' });
        }
    }

    return(
        <>
            <Load isLoading={isLoading} />
            <div className="rec-senha-content-login">
                <div className="iconTextContainer">
                    <a href="/">
                        <img className="icon" src={voltarIcon} alt="Back to the login page" />
                        <text className="back-text">Voltar</text>
                    </a>
                </div>
                <form className="rec-senha-inside-content" style={{padding: '10px'}} onSubmit={(e) => { e.preventDefault(); handleEnviarSenha(); }}>
                    {!emailEnviado ? (
                        <>  <label htmlFor="access" className="rec-senha-access-label">Recuperação de Senha</label>
                            <label htmlFor="access" className="rec-senha-access-descricao">Enviaremos as instruções para criar uma nova senha no e-mail digitado abaixo.</label>
                            <div className="rec-senha-form-group-auth">
                                <label htmlFor="email">DIGITE SEU E-MAIL</label>
                                <input type="text" 
                                    placeholder="Digite seu e-mail" 
                                    style={{maxWidth: '100%'}}
                                    onChange={(e) => handleOnChangeSenha(e.target.value)} />
                            </div>
                            <div className="rec-senha-btn-content">
                                <button className="rec-senha-btn-access" 
                                    type="submit"
                                    disabled={disabled}>Enviar</button>
                            </div>  
                        </>
                    ) : (
                        <>
                            <label htmlFor="access" className="rec-senha-access-label">Recuperação de Senha</label>
                            <label htmlFor="access" className="rec-senha-access-descricao">O e-mail com as instruções para redefinição de senha foi enviado para <strong>{destinatario}</strong>.</label>
                        </>
                    )}
                </form>
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default RecuperarSenha;